import { alereAxios } from '../utils/api';

export const getAllLoginLog = (params) =>
  alereAxios.get('users/login-log', { params });
